// @ts-nocheck
import {
    chain,
    DispatchCompleteLoadAccount,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/UserSetup/Handlers/SaveUser";
import { getCurrentEditingUser } from "@insite/client-framework/Store/Pages/UserSetup/UserSetupSelectors";
import constants from "@store/constants";
import { addToChainAfter, replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

// A bit awkward but some properties can be updated so the normal handler chain of copying the account
// won't work as sending those values on the update call will cause an error.  We add this handler to remove any properties not allowed.
addToChainAfter(chain, PopulateApiParameter, props => {
    const properties = Object.entries(props.apiParameter.account.properties);
    const filteredProperties = properties.reduce<{ [key: string]: string }>((acc, [key, value]) => {
        if (constants.allowedPropertiesForUpdate.includes(key)) {
            acc[key] = value;
        }
        return acc;
    }, {});
    props.apiParameter.account.properties = filteredProperties;
});

replaceInChain(chain, DispatchCompleteLoadAccount, props => {
    // more awkwardness. The patch call isn't properly repopulating the properties so we need to do it here.
    const editingUser = getCurrentEditingUser(props.getState());
    if (props.apiResult.successful && editingUser) {
        props.apiResult.result = editingUser;
        props.dispatch({
            type: "Data/Accounts/CompleteLoadAccount",
            model: props.apiResult.result,
        });
    }
});
